export const PSYCHOTHERAPY_MIN_BILLABLE_MINUTES = 16;

export const PSYCHOTHERAPY_90832_MIN_MINUTES = 16;
export const PSYCHOTHERAPY_90832_MAX_MINUTES = 37;

export const PSYCHOTHERAPY_90834_MIN_MINUTES = 38;
export const PSYCHOTHERAPY_90834_MAX_MINUTES = 52;

export const PSYCHOTHERAPY_90837_MIN_MINUTES = 53;

export const DIAGNOSTIC_90791_MIN_MINUTES = 16;
export const DIAGNOSTIC_90791_MAX_MINUTES = 90;

export const DIAGNOSTIC_90792_STANDARD_MINUTES = 60;
export const DIAGNOSTIC_90792_DURATION_WARNING_TOLERANCE_MINUTES = 15;

export const PSYCHOTHERAPY_ADD_ON_90833_MIN_MINUTES = 30;

export const CRISIS_90839_MIN_MINUTES = 30;
export const CRISIS_90839_MAX_MINUTES = 74;
export const CRISIS_90840_FIRST_UNIT_MIN_MINUTES = 75;
export const CRISIS_90840_FIRST_UNIT_MAX_MINUTES = 90;

export const FAMILY_THERAPY_MIN_MINUTES = 26;

export const GROUP_THERAPY_90853_MIN_MINUTES = 45;
export const GROUP_THERAPY_90853_MAX_MINUTES = 60;

export const EM_CODES_NEW = ['99202', '99203', '99204', '99205'] as const;
export const EM_CODES_ESTABLISHED = ['99212', '99213', '99214', '99215'] as const;
export const ALL_EM_CODES = [...EM_CODES_NEW, ...EM_CODES_ESTABLISHED] as const;

export const PSYCHOTHERAPY_DURATION_CODES = ['90832', '90834', '90837'] as const;

export const INTERACTIVE_COMPLEXITY_SUPPORTED_PRIMARY_CODES = [
  '90791',
  '90792',
  '90832',
  '90834',
  '90837',
  '90853',
] as const;
